// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ScreenPersonalOverview_main__iOilp {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 73px 0;
    cursor: default;
}

.ScreenPersonalOverview_container__TXFgC {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 70%;
    height: 100%;
}

.ScreenPersonalOverview_container_left__HHq6q,
.ScreenPersonalOverview_container_right__o3veI {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 48%;
    height: 100%;
}

.ScreenPersonalOverview_personal_area__BPZiG {
    width: 100%;
    /* height: calc(410px + 30px + 16px); */
    height: calc(100% - 260px);
}

.ScreenPersonalOverview_purchased_model_area__RpFG3 {
    width: 100%;
    height: calc(181px + 30px + 16px);
}

.ScreenPersonalOverview_shopping_area__0kHbc {
    width: 100%;
    height: 100%;
}

.ScreenPersonalOverview_area_header__P3-J- {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 30px;
    margin-bottom: 15px;
}

.ScreenPersonalOverview_header_img__XBWAC {
    width: 28px;
    height: 25px;
    margin-right: 8px;
}

.ScreenPersonalOverview_header_title__vhy0L {
    font-size: 20px;
    color: #101417;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
}

.ScreenPersonalOverview_more_box__oo7yS {
    margin-left: auto;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 100%;
    cursor: pointer;
    -webkit-user-select: none;
            user-select: none;
}

.ScreenPersonalOverview_more_text__ziQ5Q {
    font-size: 14px;
    font-weight: bold;
    color: #17A8B5;
    margin-right: 5px;
}

.ScreenPersonalOverview_more_img__1tUy9 {
    width: 12px;
    height: 13px;
}

.ScreenPersonalOverview_personal_box__Xpk3G,
.ScreenPersonalOverview_purchased_model_box__upBHn,
.ScreenPersonalOverview_shopping_model_box__IzddW {
    width: 100%;
    height: calc(100% - 46px);
    padding: 20px;
    border: 1px solid #D9D9D9;
    border-radius: 12px;
}

.ScreenPersonalOverview_personal_box__Xpk3G {
    padding: 30px 50px 15px;
}

.ScreenPersonalOverview_purchased_model_box__upBHn {

}

.ScreenPersonalOverview_shopping_model_box__IzddW {
    display: flex;
    flex-direction: column;
    /* justify-content: space-between; */
    overflow-x: hidden;
    overflow-y: scroll;
}

/* 自定义滚动条 */
.ScreenPersonalOverview_shopping_model_box__IzddW::-webkit-scrollbar {/*滚动条整体样式*/
    -webkit-appearance: none;
    width: 5px;
    height: 5px;
}

.ScreenPersonalOverview_shopping_model_box__IzddW::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    cursor: pointer;
    border-radius: 5px;
    background: #e9e9e9;
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.ScreenPersonalOverview_shopping_model_box__IzddW::-webkit-scrollbar-thumb:hover {
    background: #e3e3e3;
}

.ScreenPersonalOverview_model_box__gd63u {
    width: 100%;
    height: 59px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 32px;
}

.ScreenPersonalOverview_model__eTbAP {
    width: 59px;
    height: 59px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #D9D9D9;
    border-radius: 6px;
}

.ScreenPersonalOverview_model_unactive__Q0T0s {
    background-color: #ebebec;
}

.ScreenPersonalOverview_model_img__-8clq {
    width: 45px;
    height: 45px;
}

.ScreenPersonalOverview_shopping_model_item__u8uv9 {
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 93px;
    padding: 11px 7px;
    border: 1px solid #D9D9D9;
    margin-bottom: 15px;
    border-radius: 12px;
    background-color: #f9f9f9;
}

.ScreenPersonalOverview_shopping_model_item__u8uv9:last-child {
    margin-bottom: 0;
}

.ScreenPersonalOverview_shopping_model_img_box__00Ybs {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 51px;
    min-width: 51px;
    height: 51px;
    border: 1px solid #D9D9D9;
    border-radius: 6px;
    background-color: #FFF;
}

.ScreenPersonalOverview_shopping_model_img__IScIm {
    width: 38px;
    height: 38px;
}

.ScreenPersonalOverview_shopping_model_text_box__RJLDi {
    flex-grow: 1;
    padding: 0 55px 0 14px;
}

.ScreenPersonalOverview_shopping_model_text_box_unowned__Qvlpw {
    padding: 0 10px 0 14px;
}

.ScreenPersonalOverview_shopping_model_text_title__pCXHv {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
    font-size: 14px;
    color: #101417;
}

.ScreenPersonalOverview_shopping_model_text_info__Yt5ij {
    display: -webkit-box;        /* 创建一个弹性盒子 */
    -webkit-box-orient: vertical; /* 设置盒子的子元素排列方式为垂直 */
    -webkit-line-clamp: 2;       /* 限制显示两行 */
    overflow: hidden;            /* 隐藏超出内容 */
    text-overflow: ellipsis;     /* 使用省略号表示超出的文本 */
    color: #414648;
    font-size: 12px;
    line-height: 20px;
}

.ScreenPersonalOverview_shopping_model_butn__toJkm {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 28px;
    border-radius: 6px;
    font-size: 11px;
}

.ScreenPersonalOverview_shopping_model_owned__R1mDT {
    width: 83px;
    min-width: 83px;
    color: #74bdc6;
    background-color: #e4f0f2;
    border: 1px solid #74bdc6;
    border-bottom-width: 2px;
}

.ScreenPersonalOverview_shopping_model_purchase__dTyj6 {
    width: 128px;
    min-width: 128px;
    color: #EABC4E;
    background-color: #FFF;
    border: 1px solid #D9D9D9;
    border-bottom-width: 2px;
}

.ScreenPersonalOverview_model_status_img__xL0XF {
    margin-right: 5px;
}

.ScreenPersonalOverview_personal_info__l\\+Ejs {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 90px;
    margin-bottom: 15px;
}

.ScreenPersonalOverview_personal_info_img__o6weY {
    width: 90px;
    height: 90px;
    margin-right: 20px;
}

.ScreenPersonalOverview_personal_info_text_box__dxYpo {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: calc(100% - 10px);
    height: 100%;
}

.ScreenPersonalOverview_welcome_title__b3UR4 {
    font-family: 'PingFangSCMedium';
    font-size: 24px;
    color: #101417;
    font-weight: bold;
}

.ScreenPersonalOverview_welcome_info__cEp2y {
    font-family: 'PingFangSCMedium';
    font-size: 15px;
    color: #323A45;
    font-weight: bold;
}

.ScreenPersonalOverview_create_butn_box__lioOd {
    width: 100%;
    height: 58px;
    margin-bottom: 25px;
}

/* .create_butn {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 58px;
    font-size: 16px;
    color: #fff;
    border-radius: 6px;
    cursor: pointer;
    background-color: #17a8b5;
    background: url('../../../../statics/create_butn.png') no-repeat center / 100% 100%;
    transition: background 0.5s, box-shadow 0.5s;
    transform: translateZ(0);
    margin-bottom: 25px;
}

.create_butn::before {
    content: "";
    background: url('../../../../statics/create_butn_hover.png') no-repeat center / 100% 100%;
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
}

.create_butn::after {
    content: "";
    background: url('../../../../statics/create_butn_active.png') no-repeat center / 100% 100%;
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
}

.create_butn:hover {
    background: url('../../../../statics/create_butn_hover.png') no-repeat center / 100% 100%;
    box-shadow:0px 5px 10px #ddd;
}

.create_butn:active {
    background: url('../../../../statics/create_butn_active.png') no-repeat center / 100% 100%;
    box-shadow:0px 5px 10px #ddd;
} */

.ScreenPersonalOverview_personal_grade_box__mU6Bb {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 72px;
}

.ScreenPersonalOverview_first_personal_grade_box__g0Mrm {
    margin-bottom: 15px;
}

.ScreenPersonalOverview_personal_grade_item__sXapd {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 45%;
    height: 100%;
    padding-left: 20px;
    border: 1px solid #D9D9D9;
    border-radius: 6px;
}

.ScreenPersonalOverview_grade_img_box__YRs1Y {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 36px;
    height: 36px;
    max-width: 36px;
    max-height: 36px;
    margin-right: 10px;
}

.ScreenPersonalOverview_grade_img__qyuvm {
    max-width: 36px;
    max-height: 36px;
}

.ScreenPersonalOverview_grade_text_box__991dm {

}

.ScreenPersonalOverview_grade_text_title__QvdtL {
    font-size: 15px;
    color: #C1C1C1;
    line-height: 20px;
    margin-bottom: 5px;
}

.ScreenPersonalOverview_grade_text_value__mSx2F {
    font-size: 15px;
    color: #323a45;
    line-height: 20px;
    font-family: 'PingFangSCMedium';
    font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/components/ScreenPersonalOverview/index.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,YAAY;AAChB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,mBAAmB;IACnB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,uCAAuC;IACvC,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;;IAGI,WAAW;IACX,yBAAyB;IACzB,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;AAEA;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oCAAoC;IACpC,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,WAAW;AACX,sEAAwC,UAAU;IAC9C,wBAAwB;IACxB,UAAU;IACV,WAAW;AACf;;AAEA,4EAA8C,WAAW;IACrD,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IAEnB,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;IACnB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,+BAA+B;IAC/B,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,oBAAoB,SAAS,aAAa;IAC1C,4BAA4B,EAAE,oBAAoB;IAClD,qBAAqB,QAAQ,WAAW;IACxC,gBAAgB,aAAa,WAAW;IACxC,uBAAuB,MAAM,iBAAiB;IAC9C,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,cAAc;IACd,yBAAyB;IACzB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,wBAAwB;IACxB,YAAY;AAChB;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA8CG;;AAEH;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;;AAEA;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,+BAA+B;IAC/B,iBAAiB;AACrB","sourcesContent":[".main {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n    padding: 73px 0;\n    cursor: default;\n}\n\n.container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 70%;\n    height: 100%;\n}\n\n.container_left,\n.container_right {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    align-items: center;\n    width: 48%;\n    height: 100%;\n}\n\n.personal_area {\n    width: 100%;\n    /* height: calc(410px + 30px + 16px); */\n    height: calc(100% - 260px);\n}\n\n.purchased_model_area {\n    width: 100%;\n    height: calc(181px + 30px + 16px);\n}\n\n.shopping_area {\n    width: 100%;\n    height: 100%;\n}\n\n.area_header {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    width: 100%;\n    height: 30px;\n    margin-bottom: 15px;\n}\n\n.header_img {\n    width: 28px;\n    height: 25px;\n    margin-right: 8px;\n}\n\n.header_title {\n    font-size: 20px;\n    color: #101417;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n}\n\n.more_box {\n    margin-left: auto;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n    height: 100%;\n    cursor: pointer;\n    user-select: none;\n}\n\n.more_text {\n    font-size: 14px;\n    font-weight: bold;\n    color: #17A8B5;\n    margin-right: 5px;\n}\n\n.more_img {\n    width: 12px;\n    height: 13px;\n}\n\n.personal_box,\n.purchased_model_box,\n.shopping_model_box {\n    width: 100%;\n    height: calc(100% - 46px);\n    padding: 20px;\n    border: 1px solid #D9D9D9;\n    border-radius: 12px;\n}\n\n.personal_box {\n    padding: 30px 50px 15px;\n}\n\n.purchased_model_box {\n\n}\n\n.shopping_model_box {\n    display: flex;\n    flex-direction: column;\n    /* justify-content: space-between; */\n    overflow-x: hidden;\n    overflow-y: scroll;\n}\n\n/* 自定义滚动条 */\n.shopping_model_box::-webkit-scrollbar {/*滚动条整体样式*/\n    -webkit-appearance: none;\n    width: 5px;\n    height: 5px;\n}\n\n.shopping_model_box::-webkit-scrollbar-thumb {/*滚动条里面小方块*/\n    cursor: pointer;\n    border-radius: 5px;\n    background: #e9e9e9;\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.shopping_model_box::-webkit-scrollbar-thumb:hover {\n    background: #e3e3e3;\n}\n\n.model_box {\n    width: 100%;\n    height: 59px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 32px;\n}\n\n.model {\n    width: 59px;\n    height: 59px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid #D9D9D9;\n    border-radius: 6px;\n}\n\n.model_unactive {\n    background-color: #ebebec;\n}\n\n.model_img {\n    width: 45px;\n    height: 45px;\n}\n\n.shopping_model_item {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    height: 93px;\n    padding: 11px 7px;\n    border: 1px solid #D9D9D9;\n    margin-bottom: 15px;\n    border-radius: 12px;\n    background-color: #f9f9f9;\n}\n\n.shopping_model_item:last-child {\n    margin-bottom: 0;\n}\n\n.shopping_model_img_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 51px;\n    min-width: 51px;\n    height: 51px;\n    border: 1px solid #D9D9D9;\n    border-radius: 6px;\n    background-color: #FFF;\n}\n\n.shopping_model_img {\n    width: 38px;\n    height: 38px;\n}\n\n.shopping_model_text_box {\n    flex-grow: 1;\n    padding: 0 55px 0 14px;\n}\n\n.shopping_model_text_box_unowned {\n    padding: 0 10px 0 14px;\n}\n\n.shopping_model_text_title {\n    width: 100%;\n    height: 28px;\n    line-height: 28px;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n    font-size: 14px;\n    color: #101417;\n}\n\n.shopping_model_text_info {\n    display: -webkit-box;        /* 创建一个弹性盒子 */\n    -webkit-box-orient: vertical; /* 设置盒子的子元素排列方式为垂直 */\n    -webkit-line-clamp: 2;       /* 限制显示两行 */\n    overflow: hidden;            /* 隐藏超出内容 */\n    text-overflow: ellipsis;     /* 使用省略号表示超出的文本 */\n    color: #414648;\n    font-size: 12px;\n    line-height: 20px;\n}\n\n.shopping_model_butn {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 28px;\n    border-radius: 6px;\n    font-size: 11px;\n}\n\n.shopping_model_owned {\n    width: 83px;\n    min-width: 83px;\n    color: #74bdc6;\n    background-color: #e4f0f2;\n    border: 1px solid #74bdc6;\n    border-bottom-width: 2px;\n}\n\n.shopping_model_purchase {\n    width: 128px;\n    min-width: 128px;\n    color: #EABC4E;\n    background-color: #FFF;\n    border: 1px solid #D9D9D9;\n    border-bottom-width: 2px;\n}\n\n.model_status_img {\n    margin-right: 5px;\n}\n\n.personal_info {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    height: 90px;\n    margin-bottom: 15px;\n}\n\n.personal_info_img {\n    width: 90px;\n    height: 90px;\n    margin-right: 20px;\n}\n\n.personal_info_text_box {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    width: calc(100% - 10px);\n    height: 100%;\n}\n\n.welcome_title {\n    font-family: 'PingFangSCMedium';\n    font-size: 24px;\n    color: #101417;\n    font-weight: bold;\n}\n\n.welcome_info {\n    font-family: 'PingFangSCMedium';\n    font-size: 15px;\n    color: #323A45;\n    font-weight: bold;\n}\n\n.create_butn_box {\n    width: 100%;\n    height: 58px;\n    margin-bottom: 25px;\n}\n\n/* .create_butn {\n    position: relative;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 58px;\n    font-size: 16px;\n    color: #fff;\n    border-radius: 6px;\n    cursor: pointer;\n    background-color: #17a8b5;\n    background: url('../../../../statics/create_butn.png') no-repeat center / 100% 100%;\n    transition: background 0.5s, box-shadow 0.5s;\n    transform: translateZ(0);\n    margin-bottom: 25px;\n}\n\n.create_butn::before {\n    content: \"\";\n    background: url('../../../../statics/create_butn_hover.png') no-repeat center / 100% 100%;\n    position: absolute;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    z-index: -1;\n}\n\n.create_butn::after {\n    content: \"\";\n    background: url('../../../../statics/create_butn_active.png') no-repeat center / 100% 100%;\n    position: absolute;\n    width: 0;\n    height: 0;\n    overflow: hidden;\n    z-index: -1;\n}\n\n.create_butn:hover {\n    background: url('../../../../statics/create_butn_hover.png') no-repeat center / 100% 100%;\n    box-shadow:0px 5px 10px #ddd;\n}\n\n.create_butn:active {\n    background: url('../../../../statics/create_butn_active.png') no-repeat center / 100% 100%;\n    box-shadow:0px 5px 10px #ddd;\n} */\n\n.personal_grade_box {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n    height: 72px;\n}\n\n.first_personal_grade_box {\n    margin-bottom: 15px;\n}\n\n.personal_grade_item {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    width: 45%;\n    height: 100%;\n    padding-left: 20px;\n    border: 1px solid #D9D9D9;\n    border-radius: 6px;\n}\n\n.grade_img_box {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 36px;\n    height: 36px;\n    max-width: 36px;\n    max-height: 36px;\n    margin-right: 10px;\n}\n\n.grade_img {\n    max-width: 36px;\n    max-height: 36px;\n}\n\n.grade_text_box {\n\n}\n\n.grade_text_title {\n    font-size: 15px;\n    color: #C1C1C1;\n    line-height: 20px;\n    margin-bottom: 5px;\n}\n\n.grade_text_value {\n    font-size: 15px;\n    color: #323a45;\n    line-height: 20px;\n    font-family: 'PingFangSCMedium';\n    font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `ScreenPersonalOverview_main__iOilp`,
	"container": `ScreenPersonalOverview_container__TXFgC`,
	"container_left": `ScreenPersonalOverview_container_left__HHq6q`,
	"container_right": `ScreenPersonalOverview_container_right__o3veI`,
	"personal_area": `ScreenPersonalOverview_personal_area__BPZiG`,
	"purchased_model_area": `ScreenPersonalOverview_purchased_model_area__RpFG3`,
	"shopping_area": `ScreenPersonalOverview_shopping_area__0kHbc`,
	"area_header": `ScreenPersonalOverview_area_header__P3-J-`,
	"header_img": `ScreenPersonalOverview_header_img__XBWAC`,
	"header_title": `ScreenPersonalOverview_header_title__vhy0L`,
	"more_box": `ScreenPersonalOverview_more_box__oo7yS`,
	"more_text": `ScreenPersonalOverview_more_text__ziQ5Q`,
	"more_img": `ScreenPersonalOverview_more_img__1tUy9`,
	"personal_box": `ScreenPersonalOverview_personal_box__Xpk3G`,
	"purchased_model_box": `ScreenPersonalOverview_purchased_model_box__upBHn`,
	"shopping_model_box": `ScreenPersonalOverview_shopping_model_box__IzddW`,
	"model_box": `ScreenPersonalOverview_model_box__gd63u`,
	"model": `ScreenPersonalOverview_model__eTbAP`,
	"model_unactive": `ScreenPersonalOverview_model_unactive__Q0T0s`,
	"model_img": `ScreenPersonalOverview_model_img__-8clq`,
	"shopping_model_item": `ScreenPersonalOverview_shopping_model_item__u8uv9`,
	"shopping_model_img_box": `ScreenPersonalOverview_shopping_model_img_box__00Ybs`,
	"shopping_model_img": `ScreenPersonalOverview_shopping_model_img__IScIm`,
	"shopping_model_text_box": `ScreenPersonalOverview_shopping_model_text_box__RJLDi`,
	"shopping_model_text_box_unowned": `ScreenPersonalOverview_shopping_model_text_box_unowned__Qvlpw`,
	"shopping_model_text_title": `ScreenPersonalOverview_shopping_model_text_title__pCXHv`,
	"shopping_model_text_info": `ScreenPersonalOverview_shopping_model_text_info__Yt5ij`,
	"shopping_model_butn": `ScreenPersonalOverview_shopping_model_butn__toJkm`,
	"shopping_model_owned": `ScreenPersonalOverview_shopping_model_owned__R1mDT`,
	"shopping_model_purchase": `ScreenPersonalOverview_shopping_model_purchase__dTyj6`,
	"model_status_img": `ScreenPersonalOverview_model_status_img__xL0XF`,
	"personal_info": `ScreenPersonalOverview_personal_info__l+Ejs`,
	"personal_info_img": `ScreenPersonalOverview_personal_info_img__o6weY`,
	"personal_info_text_box": `ScreenPersonalOverview_personal_info_text_box__dxYpo`,
	"welcome_title": `ScreenPersonalOverview_welcome_title__b3UR4`,
	"welcome_info": `ScreenPersonalOverview_welcome_info__cEp2y`,
	"create_butn_box": `ScreenPersonalOverview_create_butn_box__lioOd`,
	"personal_grade_box": `ScreenPersonalOverview_personal_grade_box__mU6Bb`,
	"first_personal_grade_box": `ScreenPersonalOverview_first_personal_grade_box__g0Mrm`,
	"personal_grade_item": `ScreenPersonalOverview_personal_grade_item__sXapd`,
	"grade_img_box": `ScreenPersonalOverview_grade_img_box__YRs1Y`,
	"grade_img": `ScreenPersonalOverview_grade_img__qyuvm`,
	"grade_text_box": `ScreenPersonalOverview_grade_text_box__991dm`,
	"grade_text_title": `ScreenPersonalOverview_grade_text_title__QvdtL`,
	"grade_text_value": `ScreenPersonalOverview_grade_text_value__mSx2F`
};
export default ___CSS_LOADER_EXPORT___;
